// Google Analytics 4 Helper

export const GA_TRACKING_ID = 'G-XK4PXFPT39';

// Initialize GA4
export const initGA = () => {
  if (typeof window !== 'undefined' && GA_TRACKING_ID) {
    // Load gtag script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_TRACKING_ID);
  }
};

// Track page views
export const pageview = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track events
export const event = ({ action, category, label, value }) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Specific Rocket Van Express events
export const trackWhatsAppClick = (context) => {
  event({
    action: 'whatsapp_click',
    category: 'engagement',
    label: context,
  });
};

export const trackCallClick = () => {
  event({
    action: 'call_click',
    category: 'engagement',
    label: 'phone_number',
  });
};

export const trackQuoteSubmit = (quoteType) => {
  event({
    action: `quote_submit_${quoteType}`,
    category: 'conversion',
    label: quoteType,
  });
};

export const trackBusinessLead = () => {
  event({
    action: 'business_lead_submit',
    category: 'conversion',
    label: 'business_account',
  });
};

export const trackFormError = (formType, error) => {
  event({
    action: 'form_error',
    category: 'error',
    label: `${formType}_${error}`,
  });
};

export const trackScrollDepth = (depth) => {
  event({
    action: `scroll_depth_${depth}`,
    category: 'engagement',
    label: `${depth}%`,
  });
};
